import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import LightModeOutlined from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlined from '@mui/icons-material/DarkModeOutlined';
import { useTheme } from '../../context/ThemeContext';

/**
 * Bascule clair / sombre — à placer dans la navbar (desktop + mobile).
 */
export default function ThemeToggle({ className = '', compact = false }) {
  var { theme, toggleTheme } = useTheme();
  var isDark = theme === 'dark';

  return (
    <Tooltip title={isDark ? 'Passer en mode clair' : 'Passer en mode sombre'} enterDelay={300}>
      <button
        type="button"
        onClick={toggleTheme}
        className={
          'inline-flex items-center justify-center rounded-xl border transition-colors focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 dark:focus:ring-offset-slate-900 ' +
          (compact
            ? 'h-10 w-10 min-w-[40px] border-slate-200 bg-white text-amber-700 hover:bg-amber-50 dark:border-slate-600 dark:bg-slate-800 dark:text-amber-300 dark:hover:bg-slate-700 '
            : 'h-10 w-10 min-w-[40px] border-slate-200 bg-white text-slate-700 hover:bg-slate-50 dark:border-slate-600 dark:bg-slate-800 dark:text-amber-200 dark:hover:bg-slate-700 ') +
          (className ? ' ' + className : '')
        }
        aria-label={isDark ? 'Activer le thème clair' : 'Activer le thème sombre'}
        aria-pressed={isDark}
      >
        {isDark ? <LightModeOutlined sx={{ fontSize: 20 }} /> : <DarkModeOutlined sx={{ fontSize: 20 }} />}
      </button>
    </Tooltip>
  );
}
